import { cardsData } from '@/mocks/home-data';

const cardImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20dramatic%20red%20curtain%20partially%20revealing%20a%20shadowy%20figure%20in%20the%20spotlight%20on%20a%20dark%20stage%2C%20cinematic%20noir%20style%20photography%20with%20warm%20amber%20lighting%20and%20deep%20shadows%2C%20theatrical%20composition%2C%20mysterious%20atmosphere%2C%20editorial%20quality&width=800&height=500&seq=card-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20lone%20microphone%20stand%20on%20an%20empty%20concert%20stage%20with%20dramatic%20spotlight%20from%20above%2C%20backstage%20theatrical%20atmosphere%2C%20warm%20golden%20light%20rays%20piercing%20through%20darkness%2C%20poetic%20composition%2C%20editorial%20photography%20style%20with%20soft%20film%20grain&width=800&height=500&seq=card-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=A%20close-up%20of%20scattered%20luxury%20shopping%20bags%20on%20a%20marble%20floor%20with%20dramatic%20side%20lighting%2C%20some%20bags%20torn%20open%20revealing%20counterfeit%20items%2C%20investigative%20journalism%20style%2C%20warm%20and%20cool%20contrast%20lighting%2C%20high%20detail%20editorial%20photography&width=800&height=500&seq=card-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=A%20vintage%20film%20clapperboard%20lying%20cracked%20on%20a%20wooden%20floor%20with%20scattered%20torn%20script%20pages%20around%20it%2C%20dim%20atmospheric%20lighting%20with%20a%20single%20warm%20desk%20lamp%2C%20cinematic%20noir%20aesthetic%2C%20mysterious%20and%20dramatic%20composition%2C%20editorial%20quality&width=800&height=500&seq=card-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=A%20professional%20video%20editing%20suite%20with%20multiple%20monitors%20showing%20colorful%20waveform%20patterns%2C%20red%20dramatic%20warning%20indicators%20on%20screen%2C%20dim%20ambient%20lighting%20creating%20a%20tense%20atmosphere%2C%20tech%20noir%20aesthetic%2C%20editorial%20photography%20style&width=800&height=500&seq=card-05&orientation=landscape',
};

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">黑料卡片</h2>
          <p className="text-sm text-foreground-600">深度爆料 · 独家调查 · 吃瓜必看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 3).map((card) => (
            <article
              key={card.id}
              className="rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={cardImages[card.id]}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={card.title}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {card.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{card.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {card.excerpt}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {cardsData.slice(3).map((card) => (
            <article
              key={card.id}
              className="rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-56 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={cardImages[card.id]}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={card.title}
                />
              </div>
              <div className="p-5 flex flex-col justify-center flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {card.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{card.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {card.excerpt}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}